import { styled } from "@mui/material/styles";

export const CenterDiv = styled("div")({
  padding: "1rem",
  justifyContent: "center",
  width: "100%",
  display: "flex",
});
